import Grid from "../widgets/grid/grid.vue";
import Restful from '../../assets/ts/restful';
import TrackingHistory from '../tracking/modals/TrackingHistory.vue';
import TaskAssign from '../taskassign/TaskAssign.vue';

export default {
    props: [
    ],
    data() {
        var that = this;
        var selectedItems = null;
        var hiddenColumns = {};
        changeFolder = function (currentFolderId, selectedFolderId) {
            var taskIds = that.selectedItems;
            utils.callWebMethod("WebServices/FolderService.asmx", "ChangeTaskFolder",
                { taskIds: taskIds, sourceFolderId: currentFolderId, destFolderId: selectedFolderId }, function () {
                    that.reLoadeData();
                    alert(that.$t('save_successfully'));

                }, function () {
                    alert(that.$t('cartable_grid.FolderService_CanNotTransfer'));
                });
        };
        reloadGridCartabl = function () {
            that.reLoadeData();
        };
        return {
            modalData: [],
            currentModalComponent: "",
            showTrackingHistory: 0,
            boldOnField: "IsReaded",
            // detailTemplate: "<span>Sample Detail</span>",
            detailConfig: this.detailConfigFn,
            direction: payload.currentLocale.IsRightToLeft,
            columns: [],
            contextMenuItems: this.buildContextMenuItems(),
            gridContextOpen: this.contextMenuOpen,
            toolbar: this.buildToolbarItems(),
            folderId: this.$route.params.folderId,
            reloadGrid: 0,
            showTaskAssign: 0,
            currentModal: "",
            modalDataTaskAssign: {},
            height: this.getHeightOfWindow(),
            buildColumns: this.getColumns
        }
    },
    computed: {
        additionalParameters() {
            this.reloadGrid++;
            return {
                FolderId: this.$route.params.folderId,
                ParentId: this.$route.params.parentId,
                Sord: "desc",

            }
        },
        title: function () {
            var self = this;
            var title = ""; 
            $(payload.treeItems).each(function () {
                $(this.ChildItems).each(function () {
                    if (this.Id === self.$route.params.folderId)
                        title = this.Text;
                    $(this.ChildItems).each(function () {
                        if (this.Id === self.$route.params.folderId)
                            title = this.Text;
                    });
                })
            });
            return title;
        }
    },
    onDataBinding: function () {
        this.rowRecord = (this.buildDataSource.page() - 1) * (this.buildDataSource.pageSize());
    },
    //watch: {
    //    additionalParameters() {
    //        this.reloadGrid++;
    //    },
    //},
    methods: {
        getActions() {
            return [
                {
                    key: "OpenInNewWindow",
                    text: this.$t("cartable_grid.open_in_new_window"),
                    icon: "far fa-external-link",
                    action: (node, nodeData, selecteds) => {
                        let dataItem = nodeData[0];
                        window.open(`${window.location.pathname}#/taskForm/${dataItem.Id}/${this.$route.params.folderId}/${dataItem.TaskTypeId}/${dataItem.Status}/${dataItem.TaskTypeKind == '2'}`);
                    }
                },
                {
                    key: "MoveToFolder",
                    text: this.$t("cartable_grid.change_folder"),
                    icon: "far fa-folders",
                    action: (node, nodeData, selecteds) => {
                        var taskIds = [];
                        $(selecteds).each(function () { taskIds.push(this.Id); });
                        this.selectedItems = taskIds;
                        utils.showModalDialog("StaticViews/FolderSelectionPage.aspx", i18n.$t("rule_criterias.select_folder"), "400", "300", "&pId=" + '' + "&fId=" + this.$route.params.folderId + "&showDefaultFolders=true" + "&tId=" + nodeData[0].Id);
                    }
                },
                {
                    key: "Flag",
                    text: this.$t("cartable_grid.flag"),
                    icon: "far fa-flag",
                    image: "",
                    subActions: [
                        {
                            key: "no_flag",
                            text: this.$t("cartable_grid.no_flag"),
                            action: (node, nodeData, selecteds) => {
                                this.changeFlag("0", nodeData[0]);
                            }
                        },
                        {
                            key: "red_flag",
                            text: "",
                            image: "dist/red-flag.png",
                            action: (node, nodeData, selecteds) => {
                                this.changeFlag("1", nodeData[0]);
                            }
                        },
                        {
                            key: "green_flag",
                            text: "",
                            image: "dist/green-flag.png",
                            action: (node, nodeData, selecteds) => {
                                this.changeFlag("2", nodeData[0]);
                            }
                        },
                        {
                            key: "blue_flag",
                            text: "",
                            image: "dist/blue-flag.png",
                            action: (node, nodeData, selecteds) => {
                                this.changeFlag("3", nodeData[0]);
                            }
                        }
                    ]
                }
            ];
        },
        detailConfigFn: function (e) {
            var self = this;
            let dataItem = e.data;
            let detailWrapper = $('<div>');
            let detailCell = e.detailRow.children('td.k-detail-cell');
            let tags = $("<div class='cartableGridTags cartableGridDetails' style='display: inline-block'></div>")
                .append('<i class="fal fa-fw fa-lg fa-tags black"></i>')
                .append(dataItem.Tag == '' ? ' <span class="cartableGridEmptyTag">' + this.$t("insert_label") + '</span>' : ` <span>${dataItem.Tag}</span>`);
            let tagsEditFn = (e) => {
                tags.off('click.cartableGridTagsEdit');
                let tagsSpan = tags.children('span');
                let editInput = $('<input type="text"/>');
                let prevTag = tagsSpan.html();
                editInput.val(tagsSpan.hasClass('cartableGridEmptyTag') ? '' : prevTag);
                editInput.on('blur', (e) => {
                    let newTag = editInput.val();
                    //dataItem.set('Tag', newTag); // will update @dataItem but will also refresh grid row
                    $(e.target).parent().off('click.cartableGridTagsEdit').on('click.cartableGridTagsEdit', tagsEditFn);
                    if (prevTag == newTag) {
                        editInput.replaceWith(
                            $("<span class='" + (newTag == '' ? 'cartableGridEmptyTag' : '') + "'>")
                                .html(newTag == '' ? this.$t("insert_label") : newTag)
                        );
                    } else {
                        this.doAjaxRequest("WebServices/TaskInstanceService.asmx/SetTaskInstanceTag",
                            JSON.stringify({
                                taskInstanceId: dataItem.Id,
                                tag: newTag,
                                isActive: dataItem.Status == "Active" ? true : false
                            }),
                            (data) => {
                                editInput.replaceWith(
                                    $("<span class='" + (newTag == '' ? 'cartableGridEmptyTag' : '') + "'>")
                                        .html(newTag == '' ? this.$t("insert_label") : newTag)
                                );
                            },
                            null,
                            "POST"
                        );
                    }
                });
                tagsSpan.replaceWith(editInput);
            };
            tags.off('click.cartableGridTagsEdit').on('click.cartableGridTagsEdit', tagsEditFn);

            let treeHistory = $("<a  class='TreeHistory cartableGridDetails'><i class='fal fa-fw fa-lg fa-history black'></i></a>");
            let viewTreeHistory = (e) => {
                //vm.processLogTree.activate({ id: dataItem.Id });

                var url = "api/tracking/get-tree-task/" + dataItem.Id;

                var that = this;

                this.doAjaxRequest(
                    url,
                    {},
                    (data) => {
                        if (data != null && data.length) {

                            that.currentModalComponent = "TrackingHistory";
                            that.modalData = data;
                            that.showTrackingHistory++;

                        } else {
                            alert(i18n.$t("messages.not_any_record_found"));
                        }
                    });

            }
            treeHistory.on('click', viewTreeHistory);

            let graphHistory = $("<a  class='GraphHistory cartableGridDetails'><i class='fal fa-fw fa-lg fa-monitor-heart-rate black'></i></a>");
            let viewGraphHistory = (e) => {
                vm.processLog.activate({ id: dataItem.Id });
            }
            graphHistory.on('click', viewGraphHistory);

            let timeSheet = $("<a  class='TimeSheet cartableGridDetails'><i class='fal fa-fw fa-lg fa-calendar-alt black'></i></a>");
            let viewTimeSheet = (e) => {
                if (dataItem.lenght == 0)
                    return;
                let params = {
                    element: $('.bpmsTimesheetForm', this.$el)
                };
                vm.timesheet.activate({
                    id: dataItem.Id,
                    cmp: false
                }, params);
            }
            timeSheet.on('click', viewTimeSheet);

            let assignTask = $("<a  class='assignTask cartableGridDetails'><i class='fal fa-fw fa-lg fa-clipboard-user black'></i></a>");
            let viewassignTask = (e) => {
                if (dataItem.lenght == 0)
                    return;

                self.modalDataTaskAssign.ids = dataItem.Id;
                self.modalDataTaskAssign.folderId = self.$route.params.folderId;
                self.modalDataTaskAssign.callback = () => {
                    self.reLoadeData();

                    var params = {
                        text: self.$t('task_assign.messages.success_assign'),
                        type: 'information',
                        layout: 'center',
                        timeout: 3000
                    };

                    noty(params);
                };

                self.currentModal = "TaskAssign";
                self.showTaskAssign++;
            }
            assignTask.on('click', viewassignTask);

            if (dataItem.Description) detailWrapper.append($("<p>").html(dataItem.Description));
            detailWrapper.append(timeSheet)
            if (dataItem.IsByTreeHistory) detailWrapper.append(treeHistory);
            if (dataItem.IsByGraphHistory) detailWrapper.append(graphHistory);
            if (dataItem.IsAssignable) detailWrapper.append(assignTask);
            detailWrapper.append(tags);
            detailCell.append(detailWrapper);
        },
        contextMenuOpen(selecteds, node, nodeData, selectedNodes) {
            let mapping = (value) => {
                return {
                    key: value.key,
                    icon: value.icon,
                    text: value.text,
                    imageUrl: value.image,
                    action: value.action,
                    items: value.subActions ?
                        value.subActions.map(mapping) :
                        undefined
                };
            };
            var taskIds = [];
            $(selecteds).each(function () {
                var n = $(this).children('td').children('input[type="checkbox"]')[0];
                var t = $(n).attr('taskid');
                taskIds.push(t);
            });
            var n = $(node).children('td').children('input[type="checkbox"]')[0];
            var nodeTaskId = $(n).attr('taskid');

            var isAssign = nodeData.IsAssignable;
            $(selectedNodes).each(function () {
                if (!this.IsAssignable) {
                    isAssign = false;
                }
            });

            var isFormLessEvents = nodeData.HasFormlessEvents;
            var actions = this.getActions();
            if (isAssign) {
                actions.push(
                    {
                        key: "assignTask",
                        text: this.$t("cartable_grid.assignTask"),
                        icon: "far fa-clipboard-user",
                        // image: "dist/assignTask.png",
                        action: (node, nodeData, selecteds) => {
                            var taskIds = [];
                            $(selectedNodes).each(function () { taskIds.push(this.Id); });

                            self.modalDataTaskAssign.ids = taskIds;
                            self.modalDataTaskAssign.folderId = self.$route.params.folderId;
                            self.modalDataTaskAssign.callback = () => {
                                self.reLoadeData();

                                var params = {
                                    text: self.$t('task_assign.messages.success_assign'),
                                    type: 'information',
                                    layout: 'center',
                                    timeout: 3000
                                };

                                noty(params);
                            };

                            self.currentModal = "TaskAssign";
                            self.showTaskAssign++;
                        }
                    }
                );
            }
            var self = this;
            self.contextMenuItems = actions.map(mapping);
            if (isFormLessEvents) {
                Restful.get(
                    "api/FormlessEvents/", { taskIds: taskIds }, null
                ).done((data) => {
                    $(data).each(function () {
                        if (this.TaskId === nodeTaskId) {
                            $(this.Events).each(function () {
                                var messageList = '';
                                actions.push(
                                    {
                                        key: this.Id,
                                        text: this.Title,
                                        image: "",
                                        action: (node, nodeData) => {
                                            var id = this.Id;
                                            var buttons = [];
                                            buttons[i18n.$t("close")] = function () {
                                                $(messageList).rayModal('close');
                                                self.reLoadeData();
                                            }
                                            Restful.post(
                                                "api/FormlessEvents/" + id, taskIds, null, true).done(function (rslt) {
                                                    var infos = rslt;
                                                    $(self.$el).LoadingOverlay('hide');
                                                    if (infos && infos.length > 0) {
                                                        messageList = $('<ul>').addClass("bpmsInfo  formLess-events-message");
                                                        var ix = 0;
                                                        for (var i = 0; i < infos.length; i++)
                                                            messageList.append($('<li class="' + infos[i].TypeStr + '" />').append((infos[i].IsHeading ? "<h1>" + (++ix) + ". " : "<h2>") + infos[i].Title + (infos[i].IsHeading ? "</h1>" : "</h2>")).append("<pre>" + infos[i].Message + "</pre>"));

                                                        utils.showGenericModalWithContainer("", messageList, self.taskEventCallBack, buttons);
                                                    }
                                                }).fail(function (ex) {
                                                    var err = ex.responseJSON;
                                                    console.log(err);
                                                    messageList = $('<ul>').addClass("bpmsInfo");
                                                    messageList.append("<pre>" + err.ExceptionMessage + "</pre>");
                                                    utils.showGenericModalWithContainer("", messageList, self.taskEventCallBack, buttons);
                                                    $(self.$el).LoadingOverlay('hide');
                                                });
                                            $(self.$el).LoadingOverlay('show', {
                                                zIndex: 100000
                                            });
                                        }
                                    }
                                );
                                self.contextMenuItems = actions.map(mapping);
                            });
                            return;
                        }
                    });
                });
            }
        },
        taskEventCallBack() {
            if (payload.IsPlugin) {
                window.bpmsClose('');
                return;
            }
            this.reLoadeData();
        },
        reLoadeData() {
            this.reloadGrid++;
        },
        buildContextMenuItems() {
            let mapping = (value) => {
                return {
                    key: value.key,
                    text: value.text,
                    icon: value.icon,
                    imageUrl: value.image,
                    action: value.action,
                    items: value.subActions ?
                        value.subActions.map(mapping) :
                        undefined
                };
            };
            return this.getActions().map(mapping);
        },

        buildToolbarItems() {
            let mapping = (value) => {
                let hasSubActions = Array.isArray(value.subActions);
                return {
                    type: hasSubActions ? "splitButton" : "button",
                    text: (value.icon) ?
                        `<i class="${value.icon} fa-fw fa-lg"></i> ${value.text}` :
                        value.text,
                    enable: false,
                    click: value.action,
                    imageUrl: value.image,
                    menuButtons: hasSubActions ? value.subActions.map(mapping) : undefined
                }
            };
            return this.getActions().map(mapping);
        },

        getColumns(onSuccess) {
            this.customGridColumnWidth = JSON.parse(window.localStorage.getItem('CartableGridColumnWidth'));
            if (!this.customGridColumnWidth) {
                this.customGridColumnWidth = [];
            }
            this.columns = [
                { field: "Id", name: "Id", title: this.$t('id'), menu: false, hidden: true },
                {
                    field: "RowNumber", name: "RowNumber", title: this.$t('RowNumber'),
                    width: this.customGridColumnWidth.find(x => x.name == "RowNumber") ? this.customGridColumnWidth.find(x => x.name == "RowNumber").width : 30
                    , template: "#=++ payload.TaskGridRecord #"
                },
                {
                    field: "Flag", name: "Flag", title: this.$t('cartable_grid.flag'), filterable: false, sortable: true,
                    width: this.customGridColumnWidth.find(x => x.name == "Flag") ? this.customGridColumnWidth.find(x => x.name == "Flag").width : 70,
                    template: (dataItem) => {
                        let image = "empty.png";
                        switch (dataItem.Flag) {
                            case 1:
                                image = 'red-flag.png';
                                break;
                            case 2:
                                image = 'green-flag.png';
                                break;
                            case 3:
                                image = 'blue-flag.png';
                                break;
                        }
                        return `<img src='./dist/${image}' class='flag' taskId='${dataItem.Id}'/>`;
                    }
                    , minScreenWidth: 810
                },
                {
                    field: "PriorityId", name: "PriorityId", title: this.$t('priority'), filterable: false, sortable: true,
                    width: this.customGridColumnWidth.find(x => x.name == "PriorityId") ? this.customGridColumnWidth.find(x => x.name == "PriorityId").width : 89,
                    template: (dataItem) => {
                        let image, title;
                        switch (dataItem.PriorityId) {
                            case 1:
                                image = "prioritylow", title = this.$t('priority_low');
                                break;
                            case 2:
                                image = "prioritym", title = this.$t('priority_normal');
                                break;
                            case 3:
                                image = "priorityh", title = this.$t('priority_high');
                                break;
                            case 4:
                                image = "priorityvh", title = this.$t('priority_very_high');
                                break;
                            default:
                                image = "empty", title = "";
                        }
                        return `<img src='dist/${image}.png' title='${title}'/>`;
                    },
                    minScreenWidth: 620

                },
                {
                    field: "Subject", name: "Subject", title: this.$t('subject'),
                    width: this.customGridColumnWidth.find(x => x.name == "Subject") ? this.customGridColumnWidth.find(x => x.name == "Subject").width : 250,
                    filterable: false, sortable: true,
                    template: (dataItem) => {
                        var isDraft = dataItem.TaskTypeKind == '2';
                        var isNotification = dataItem.TaskTypeKind == '1';
                        let plugin = payload.isPlugin ? '?co=t' : ''

                        let params = {
                            id: dataItem.Id,
                            folderId: this.$route.params.folderId,
                            taskTypeId: dataItem.TaskTypeId,
                            status: dataItem.Status,
                            isDraft: isDraft
                        };

                        let paramsStr = JSON.stringify(params).replace(/"/gmi, "'")

                        var result = isNotification ? `<a title="${dataItem.Subject}" href='${window.location.pathname}${plugin}#/taskForm/${dataItem.Id}/${this.$route.params.folderId}/${dataItem.TaskTypeId}/${dataItem.Status}/${isDraft}'> <span class='glyphicon glyphicon-bell transcript-icon'></span> <span > ${dataItem.Subject} </span></a>` : `<a title="${dataItem.Subject}" href='${window.location.pathname}${plugin}#/taskForm/${dataItem.Id}/${this.$route.params.folderId}/${dataItem.TaskTypeId}/${dataItem.Status}/${isDraft}'>${dataItem.Subject}</a>`;

                        return result;
                    },
                    minwidth: 200
                },
                {
                    field: "CreationDate", name: "CreationDate", title: this.$t('created_date'), filterable: false, sortable: true,
                    width: this.customGridColumnWidth.find(x => x.name == "CreationDate") ? this.customGridColumnWidth.find(x => x.name == "CreationDate").width : 120,
                    template: (dataItem) => {
                        if (payload.isExactDate == 'false' || payload.isExactDate == 'undefined') {
                            var ret = $.timeago(dataItem.CreationDate);
                            ret = this.ChangeDateNumbersToPersianFormat(ret);
                            return ret;
                        }
                        return dataItem.CreationDate;
                    },
                    minScreenWidth: 670
                },
                {
                    field: "ResponseDate", name: "ResponseDate", title: this.$t('response_deadline'), filterable: false, sortable: true, minScreenWidth: 200,
                    width: this.customGridColumnWidth.find(x => x.name == "ResponseDate") ? this.customGridColumnWidth.find(x => x.name == "ResponseDate").width : 120,
                    minScreenWidth: 770,
                    template: (dataItem) => {
                        if (dataItem.ResponseDate != '' && dataItem.ResponseDate != null && (payload.isExactDate == 'false' || payload.isExactDate == 'undefined')) {
                            var ret = $.timeago(dataItem.ResponseDate);
                            ret = this.ChangeDateNumbersToPersianFormat(ret);
                            return ret;
                        }
                        return dataItem.ResponseDate;
                    }
                },
                {
                    field: "DoneDate", name: "DoneDate", title: this.$t('done_date'), filterable: false, sortable: true, minScreenWidth: 500,
                    width: this.customGridColumnWidth.find(x => x.name == "DoneDate") ? this.customGridColumnWidth.find(x => x.name == "DoneDate").width : 120,
                    minScreenWidth: 860,
                    template: (dataItem) => {
                        if (dataItem.DoneDate != '' && dataItem.DoneDate != null && (payload.isExactDate == 'false' || payload.isExactDate == 'undefined')) {
                            var ret = $.timeago(dataItem.DoneDate);
                            ret = this.ChangeDateNumbersToPersianFormat(ret);
                            return ret;
                        }
                        if (dataItem.DoneDate === null)
                            dataItem.DoneDate = "";

                        return dataItem.DoneDate;
                    }
                },
                {
                    field: "Sender", name: "Sender", title: this.$t('sender'), filterable: false, sortable: true, minScreenWidth: 500,
                    width: this.customGridColumnWidth.find(x => x.name == "Sender") ? this.customGridColumnWidth.find(x => x.name == "Sender").width : 120,
                    minScreenWidth: 720
                },
                {
                    field: "StarterUser", name: "StarterUser", title: this.$t('starter_user'),
                    width: this.customGridColumnWidth.find(x => x.name == "StarterUser") ? this.customGridColumnWidth.find(x => x.name == "StarterUser").width : 120,
                    filterable: false, sortable: true, hidden: true
                },
                {
                    field: "StarterStaff", name: "StarterStaff", title: this.$t('starter_staff'),
                    width: this.customGridColumnWidth.find(x => x.name == "StarterStaff") ? this.customGridColumnWidth.find(x => x.name == "StarterStaff").width : 120,
                    filterable: false, sortable: true, hidden: true
                },
                {
                    field: "IsAssignable", name: "IsAssignable", title: this.$t('is_assignable'),
                    width: this.customGridColumnWidth.find(x => x.name == "IsAssignable") ? this.customGridColumnWidth.find(x => x.name == "IsAssignable").width : 120,
                    filterable: false, sortable: false, hidden: true, menu: false
                },
                {
                    field: "IsByGraphHistory", name: "IsByGraphHistory", title: '',
                    width: this.customGridColumnWidth.find(x => x.name == "IsByGraphHistory") ? this.customGridColumnWidth.find(x => x.name == "IsByGraphHistory").width : 120,
                    filterable: false, sortable: false, hidden: true, menu: false
                },
                {
                    field: "IsByTreeHistory", name: "IsByTreeHistory", title: '',
                    width: this.customGridColumnWidth.find(x => x.name == "IsByTreeHistory") ? this.customGridColumnWidth.find(x => x.name == "IsByTreeHistory").width : 120,
                    filterable: false, sortable: false, hidden: true, menu: false
                },
                {
                    field: "HasFormlessEvents", name: "HasFormlessEvents", title: this.$t('has_form_less_events'),
                    width: this.customGridColumnWidth.find(x => x.name == "HasFormlessEvents") ? this.customGridColumnWidth.find(x => x.name == "HasFormlessEvents").width : 120,
                    menu: false, hidden: true
                }
            ];
            var cells = this.columns;

            let taskTypeId = this.$route.params.folderId;
            if (taskTypeId != null && taskTypeId != '') {
                var url = "api/tasks/get-columns/" + taskTypeId;
                var that = this;

                this.doAjaxRequest(
                    url,
                    {},
                    (data) => {
                        if (data != null && data.length) {
                            $(data).each(function () {

                                cells.push(
                                    {
                                        field: this.Name, name: this.Name, title: this.Title, filterable: false, sortable: true,
                                        filterable: false, sortable: true, hidden: !this.Default, width: 150
                                    }
                                );
                            });

                        }
                        that.columns = cells;
                        if (typeof onSuccess === 'function')
                            onSuccess();
                    });
            }
            //let params = {
            //    id: dataItem.Id,
            //    folderId: this.$route.params.folderId,
            //    taskTypeId: dataItem.TaskTypeId,
            //}
        },
        getHeightOfWindow() {
            var totalHeight = window.innerHeight;
            totalHeight = totalHeight - 150;
            if (!payload.hideFooter) {
                totalHeight = totalHeight - 20;
            }
            if (payload.isBanner === true) {
                totalHeight = totalHeight - 149;
            }
            return totalHeight;
        },
        changeFlag(flag, nodeData) {
            this.doAjaxRequest(
                "api/tasks/SetTaskInstanceFlag",
                {
                    flagId: flag,
                    isActive: nodeData.Status == "Active" ? "true" : "false",
                    taskInstanceId: nodeData.Id
                },
                (data) => {
                    nodeData.set('Flag', parseInt(flag));
                });
        },
        doAjaxRequest(url, data, onSuccess, onFailure, method) {
            let ajaxConfig = {
                url: url,
                data: data,
                dataType: "json",
                beforeSend: function (xhr) {
                    //TODO:AccessToken
                    if (window.sessionStorage.getItem('accessToken')) {
                        xhr.setRequestHeader('rayheader', window.sessionStorage.getItem('accessToken'));
                    }
                    xhr.setRequestHeader("__RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
                },
                contentType: "application/json;charset=utf-8"
            }
            if (method) {
                ajaxConfig.method = method;
            }
            $.ajax(ajaxConfig).done((result) => {
                if (typeof onSuccess === 'function')
                    onSuccess(result);
            }).error((error) => {
                console.log(error);
                if (typeof onFailure === 'function')
                    onFailure();
            });
        },
        ChangeDateNumbersToPersianFormat(date) {
            if ((payload.currentLocale.IsRightToLeft)) {
                var ret = date.replace(/1/g, '۱');
                ret = ret.replace(/2/g, '۲');
                ret = ret.replace(/3/g, '۳');
                ret = ret.replace(/4/g, '۴');
                ret = ret.replace(/5/g, '۵');
                ret = ret.replace(/6/g, '۶');
                ret = ret.replace(/7/g, '۷');
                ret = ret.replace(/8/g, '۸');
                ret = ret.replace(/9/g, '۹');
                ret = ret.replace(/0/g, '۰');
                return ret;
            }
            else return date;
        }
    },
    updated() {
    },
    mounted() {
        //    this.additionalParameters = {
        //        FolderId: this.$route.params.folderId,
        //        TaskTypeId: this.$route.params.taskTypeId,
        //        Sidx: "CreationDate",
        //        Sord: "desc"
        //    };
    },
    components: {
        Grid,
        TrackingHistory,
        TaskAssign
    }
}
